













































































































































































































































import { Component } from "vue-property-decorator"
import Super from "@/pv4-super-class"
import TaskReview from "./TaskReview.vue"
import {
  parseISO,
  format,
  parseJSON,
  endOfWeek,
  addDays,
  endOfToday,
  startOfToday
} from "date-fns"
import { find, filter, capitalize, isNil } from "lodash"
import { BModalConfig } from "buefy/types/components"
import Pagination from "@/components/Pagination.vue"

@Component({ components: { Pagination } })
export default class TaskAllEvent extends Super {
  tasks: any = null
  users: any = null
  selectedUser: number | null = null
  viewableTasks: any = {}
  includeCompleted = false

  currentPage = 1
  itemsPerPage = 5

  mounted() {
    this.load()
  }

  load() {
    this.http
      .get(`/task?eventID=${this.eventId}`)
      .then(res => (this.tasks = res.data))

    this.http.get(`/account/list`).then(res => (this.users = res.data))
  }

  filterTasks(taskAssigneeID: number | string) {
    if (isNil(taskAssigneeID)) {
      if (this.includeCompleted) {
        return this.tasks
      } else {
        return filter(this.tasks, { taskStatus: 0 })
      }
    } else {
      if (this.includeCompleted) {
        return filter(this.tasks, { taskAssigneeID })
      } else {
        return filter(this.tasks, { taskAssigneeID, taskStatus: 0 })
      }
    }
  }

  //allows the user to reviews the details of the task.
  openTaskReviewer(task: any) {
    const config: BModalConfig = {
      parent: this,
      component: TaskReview,
      props: {
        eventId: this.eventId,
        taskId: task.taskID
      }
    }
    this.$buefy.modal.open(config).$on("close", this.load)
  }

  //counts how many tasks are marked as incomplete, this is displayed to the
  //user at the top of the tasks list
  countTasks(taskID: any) {
    let counter = 0
    if (taskID == null) {
      this.tasks.forEach(task => {
        if (task.taskStatus == 0) {
          counter++
        }
      })
    } else {
      this.tasks.forEach(task => {
        if (task.taskAssigneeID == taskID && task.taskStatus == 0) {
          counter++
        }
      })
    }
    return counter
  }

  //this shows how many tasks need to be completed before the end of the week (Sunday)
  //have a look at reduce for this
  tasksDueThisWeek(taskID: any) {
    let counter = 0
    let currentDate = addDays(new Date(), -1)

    if (taskID == null) {
      this.tasks.forEach(task => {
        let taskDate: Date = parseJSON(task.taskDueDate!)
        if (task.taskStatus == 0) {
          if (
            taskDate > currentDate &&
            taskDate < endOfWeek(currentDate, { weekStartsOn: 1 })
          ) {
            counter++
          }
        }
      })
    } else {
      this.tasks.forEach(task => {
        if (taskID == task.taskAssigneeID && task.taskStatus == 0) {
          let taskDate: Date = parseJSON(task.taskDueDate!)
          if (
            taskDate > currentDate &&
            taskDate < endOfWeek(currentDate, { weekStartsOn: 1 })
          ) {
            counter++
          }
        }
      })
    }
    return counter
  }

  //counts how many tasks are overdue (starts counting from yesterday)
  overdueTasks(taskID: any) {
    let counter = 0

    if (taskID == null) {
      this.tasks.forEach(task => {
        if (this.isTaskOverDue(task.taskDueDate!) && task.taskStatus == 0) {
          counter++
        }
      })
    } else {
      this.tasks.forEach(task => {
        if (
          this.isTaskOverDue(task.taskDueDate!) &&
          task.taskAssigneeID == taskID &&
          task.taskStatus == 0
        ) {
          counter++
        }
      })
    }
    return counter
  }

  isTaskOverDue(taskDate: string) {
    return (
      parseJSON(taskDate) < endOfToday() && parseJSON(taskDate) < startOfToday()
    )
  }

  //gets the users samName based on thier userID
  getUser(userID: string) {
    let user = this.users.find(user => user.userID == userID)
    if (user) {
      return user.samName
    } else {
      return "All.Users"
    }
  }

  //converts samName in to the first and last name
  namify(samName: string) {
    const [firstname, lastname] = samName.split(".")
    return `${capitalize(firstname)} ${capitalize(lastname)}`
  }

  //gets a task based on taskID from list of tasks
  getTask(taskID: string | number) {
    return find(this.tasks, { taskID })
  }

  //formats the date to a nicer look
  formatTimestamp(timestamp) {
    return format(parseISO(timestamp), "dd MMM yyyy")
  }
}
